module.exports = __webpack_public_path__ + "static/media/500001.1df9ad35.svg";